(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dynamic-logo-list-collapse"] && !window.DesignMode) return;
  try {
    
  const collapseContainer = document.querySelector('.collapse-container');
  const collapseButton = document.querySelector('.collapse-header .collapse--button');
  
  collapseContainer.style.display = 'none';
  
  collapseButton.addEventListener('click', () => {
      if (collapseContainer.style.display === 'none') {
          collapseContainer.style.display = 'block';
          collapseButton.textContent = 'Ver menos';
  
          collapseContainer.classList.add('slide-in-up');
          collapseContainer.addEventListener('animationend', () => {
              collapseContainer.classList.remove('slide-in-up');
          });
      } else {
          collapseContainer.style.display = 'none';
          collapseButton.textContent = 'Ver más';
  
          collapseContainer.classList.add('slide-out-down');
          collapseContainer.addEventListener('animationend', () => {
              collapseContainer.classList.remove('slide-out-down');
          });
      }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-slideshow"] && !window.DesignMode) return;
  try {
    
const { Section, Carousel } = window.PxuThemeSections;

class SlideshowSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.id = $root.id;
    this.data = this.loadData();
    this.autoplay = this.data.autoplay;
    this.autoplayDuration = this.data.autoplayDuration * 1000;
    this.carousel = null;

    this.onMount();
  }

  onMount() {
    const options = {
      autoPlay: this.autoplay ? this.autoplayDuration : false,
      prevNextButtons: true,
      lazyLoad: true
    };

    const mobileOptions = {
      draggable: true,
      autoPlay: this.autoplay ? this.autoplayDuration : false,
      lazyLoad: true
    };

    this.carousel = new Carousel(this.$root, options, mobileOptions);
    this.carousel.onMount();
  }

  onUnmount() {
    this.carousel.onUnmount();
    this.carousel = null;
  }

  onBlockSelect(event) {
    if (!this.carousel) return;
    const $slide = event.target.parentElement;
    this.carousel.selectSlide($slide);
  }
}

document.querySelectorAll('[data-pxu-slideshow]').forEach(($section) => {
  Section.init($section, SlideshowSection);
});

// export class for theme editor instance management
if (Shopify.designMode) {
  window.PxuThemeSections.SlideshowSection = SlideshowSection;
}

  } catch(e) { console.error(e); }
})();
})();
